import axios from "axios";

// You can use your own logic to set your local or production domain
const baseDomain = process.env.API_ENDPOINT;

const baseURL = `https://${baseDomain}`;

export default axios.create({
  baseURL,
  // headers: {
  //   Authorization: "Bearer ",
  //   "Ocp-Apim-Subscription-Key": process.env.SUBSCRIPTION_KEY,
  // },
});



// WEBPACK FOOTER //
// ./src/repositories/Repository.js